import { useQuery } from '@tanstack/react-query';
import { recipeService } from '@/services/recipe';
import { RECIPES, getEntityKey } from '@/constants/queryKeys';
import { Recipe } from '@/types/recipe';

export const useRecipeById = (id: string | undefined) => {
  return useQuery({
    queryKey: getEntityKey(RECIPES, id),
    queryFn: () => recipeService.getRecipeById(id!),
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 24 * 60 * 60 * 1000, // 24 hours
  });
};